import * as e from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Table.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...a, weights: m }));
o.displayName = "TableIcon";
const n = o;
export {
  n as Table,
  o as TableIcon
};
